export default __webpack_public_path__ + "static/media/ader-mssii.3b538ad7.svg";